// extracted by mini-css-extract-plugin
export default {"pageWrapper":"styles_pageWrapper__npCtJ","contentWrapper":"styles_contentWrapper__G2ztf"};